export default "__VITE_ASSET__5u$XaZFO__"